module.exports = __webpack_public_path__ + "img/top.38e65492.png";